module.exports = __webpack_public_path__ + "img/tpc-34.97b76a85.webp";